import ForgetPassword from "../Components/Pages/Others/Authentication/ForgetPassword";
import LoginSimple from "../Components/Pages/Others/Authentication/LoginSimple";
import LoginSweetAlert from "../Components/Pages/Others/Authentication/LoginSweetAlert";
import LoginWithBgImage from "../Components/Pages/Others/Authentication/LoginWithBgImage";
import LoginWithImageTwo from "../Components/Pages/Others/Authentication/LoginWithImageTwo";
import LoginWithTooltip from "../Components/Pages/Others/Authentication/LoginWithTooltip";
import LoginWithValidation from "../Components/Pages/Others/Authentication/LoginWithValidation";
import Maintenance from "../Components/Pages/Others/Authentication/Maintenance";
import RegisterSimple from "../Components/Pages/Others/Authentication/RegisterSimple";
import RegisterWithBgImage from "../Components/Pages/Others/Authentication/RegisterWithBgImage";
import RegisterWithImageTwo from "../Components/Pages/Others/Authentication/RegisterWithImageTwo";
import RegisterWizard from "../Components/Pages/Others/Authentication/RegisterWizard";
import ResetPassword from "../Components/Pages/Others/Authentication/ResetPassword";
import UnlockUser from "../Components/Pages/Others/Authentication/UnlockUser";
import ComingWithBgImage from "../Components/Pages/Others/ComingSoon/ComingWithBgImage";
import ComingWithBgVideo from "../Components/Pages/Others/ComingSoon/ComingWithBgVideo";
import SimpleComingSoon from "../Components/Pages/Others/ComingSoon/SimpleComingSoon";
import Error400 from "../Components/Pages/Others/ErrorPage/Error400";
import Error401 from "../Components/Pages/Others/ErrorPage/Error401";
import Error403 from "../Components/Pages/Others/ErrorPage/Error403";
import Error404 from "../Components/Pages/Others/ErrorPage/Error404";
import Error500 from "../Components/Pages/Others/ErrorPage/Error500";
import Error503 from "../Components/Pages/Others/ErrorPage/Error503";
import Invoice1 from "../Pages/Applications/ECommerce/Invoice/Invoice1";
import Invoice2 from "../Pages/Applications/ECommerce/Invoice/Invoice2";
import Invoice3 from "../Pages/Applications/ECommerce/Invoice/Invoice3";
import Invoice4 from "../Pages/Applications/ECommerce/Invoice/Invoice4";
import Invoice5 from "../Pages/Applications/ECommerce/Invoice/Invoice5";

export const authRoutes = [
  // Error Pages
  { path: `${process.env.PUBLIC_URL}/others/error-page-400`, element: <Error400 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-401`, element: <Error401 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-403`, element: <Error403 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-404`, element: <Error404 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-500`, element: <Error500 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-page-503`, element: <Error503 /> },
  //Coming Soon Pages
  { path: `${process.env.PUBLIC_URL}/coming-soon/coming-simple`, element: <SimpleComingSoon /> },
  { path: `${process.env.PUBLIC_URL}/coming-soon/coming-bg-video`, element: <ComingWithBgVideo /> },
  { path: `${process.env.PUBLIC_URL}/coming-soon/coming-bg-img`, element: <ComingWithBgImage /> },
  // Authentication
  { path: `${process.env.PUBLIC_URL}/auth/login`, element: <LoginSimple /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bg-img`, element: <LoginWithBgImage /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bg-img2`, element: <LoginWithImageTwo /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bs-validation`, element: <LoginWithValidation /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-bs-tooltip`, element: <LoginWithTooltip /> },
  { path: `${process.env.PUBLIC_URL}/auth/login-sweetalert`, element: <LoginSweetAlert /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up`, element: <RegisterSimple /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up-one`, element: <RegisterWithBgImage /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up-two`, element: <RegisterWithImageTwo /> },
  { path: `${process.env.PUBLIC_URL}/auth/unlock`, element: <UnlockUser /> },
  { path: `${process.env.PUBLIC_URL}/auth/forget-password`, element: <ForgetPassword /> },
  { path: `${process.env.PUBLIC_URL}/auth/reset-password`, element: <ResetPassword /> },
  { path: `${process.env.PUBLIC_URL}/auth/maintenance`, element: <Maintenance /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up-wizard`, element: <RegisterWizard /> },

  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-1`, element: <Invoice1 /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-2`, element: <Invoice2 /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-3`, element: <Invoice3 /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-4`, element: <Invoice4 /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-5`, element: <Invoice5 /> },
];
